export const authButton = 'Ingresar';
export const graphicalMaterialButton = 'Material Gráfico';
export const scanButton = 'Escanear cupón';
export const giveStamps = 'Marcar tarjeta cliente';
